import React from 'react';
import Banner from '../components/Banner';
import Breadcrumb from '../components/Breadcrumb';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import '../styles/pages/Contact.css';
import ContactBg from '../images/contact-bg.jpg'
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";

const Contact = () => {

    const fadeLeft = {
        hidden: { opacity: 0, x: -80 },
        show: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeRight = {
        hidden: { opacity: 0, x: 80 },
        show: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const container = {
        hidden: {},
        show: {
            transition: { staggerChildren: 0.15 }
        }
    };

    const item = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };


    const offices = [
        {
            icon: <FiMapPin />,
            title: "USA OFFICE",
            content: [
                "FORTUNE CLOUD SOLUTIONS LLC,",
                "5717 Legacy Drive, Suite 250",
                " Plano, Texas, 75024,",
                "United States of America - USA"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "UK OFFICE",
            content: [
                "FORTUNE CLOUD SOLUTIONS LTD",
                "2nd Floor College House 17 King Edwards Road,",
                "RUISLIP, London, HA4 7AE- UNITED KINGDOM"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "CANADA OFFICE",
            content: [
                "FORTUNE CLOUD SOLUTIONS INC",
                "15 Wellesely Street West, Suite 201",
                "Toronto, Ontario M5V 3L9 - CANADA"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "HYDERABAD OFFICE",
            content: [
                "FORTUNE CLOUD SOLUTIONS LLC,",
                "Level 2, Oval Building Plot no.18, iLabs,",
                "Hyderabad Technology Park,",
                "Hyderabad 500081"
            ]
        },
        
        {
            icon: <FiMail />,
            title: "CONTACT US",
            content: [
                // { type: "email", value: "careers@fcsglobal.us" },
                { type: "email", value: "info@fcsglobal.us" },
                { type: "phone", value: "+1 254 276 0066" }
            ]
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO 
                title="Contact Us | Fortune Cloud Solutions" 
                description="Get in touch with Fortune Cloud Solutions for IT staffing, training, and career development services. Our team is here to help you succeed." 
                canonical="https://fcsglobal.us/contact"
            />
            <Banner title="CONTACT US" image={ContactBg} />
            <div className="contact-section py-4">
                <Breadcrumb />
                {/* Contact Main */}
                <section className=" ">
                    <div className="container ">
                        <div className="row g-0 align-items-center">

                            {/* LEFT MAP */}
                            <motion.div
                                className="col-lg-6 map-wrapper"
                                variants={fadeLeft}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, margin: "-80px" }}
                            >
                                <iframe
                                    title="Google Map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3343.1637896731727!2d-96.8199016!3d33.0784753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c3cb15959334d%3A0x1f7d18088d9ed2ca!2s5717%20Legacy%20Dr%20Suite%20250%2C%20Plano%2C%20TX%2075024%2C%20USA!5e0!3m2!1sen!2sin!4v1776404959499!5m2!1sen!2sin"
                                    width="100%"
                                    height="600"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                ></iframe>
                            </motion.div>

                            {/* RIGHT FORM */}
                            <motion.div
                                className="col-lg-6 form-wrapper"
                                variants={fadeRight}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, margin: "-80px" }}
                            >
                                <div className="form-inner">

                                    <div className="section-heading">
                                        <span className="heading-line"></span>
                                        <h2>CONTACT US</h2>
                                    </div>

                                    <form className="contact-form">

                                        <div className="row g-4">
                                            <div className="col-md-6">
                                                <input type="text" placeholder="NAME" />
                                            </div>

                                            <div className="col-md-6">
                                                <input type="email" placeholder="E-MAIL" />
                                            </div>

                                            <div className="col-md-6">
                                                <input type="text" placeholder="PHONE NUMBER" />
                                            </div>

                                            <div className="col-md-6">
                                                <input type="text" placeholder="YOUR WEBSITE" />
                                            </div>

                                            <div className="col-12">
                                                <textarea rows="5" placeholder="YOUR MESSAGE HERE"></textarea>
                                            </div>

                                            <div className="col-12">
                                                <button type="submit" className="submit-btn">
                                                    SUBMIT NOW
                                                </button>
                                            </div>
                                        </div>

                                    </form>

                                </div>
                            </motion.div>

                        </div>
                    </div>
                </section>
                {/* Address */}
                <section className="office-section">
                    <div className="container">
                        <motion.div
                            className="row g-4 justify-content-center"
                            variants={container}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-80px" }}
                        >
                            {offices.map((office, index) => (
                                <motion.div
                                    key={index}
                                    className="col-lg-3 col-md-4"
                                    variants={item}
                                    whileHover={{ y: -8 }}
                                >
                                    <div className="office-card">

                                        <div className="icon-wrapper">
                                            {office.icon}
                                        </div>

                                        <h4>{office.title}</h4>

                                        <div className="office-content">
                                            {office.content.map((line, i) => {
                                                if (typeof line === "string") {
                                                    return <p key={i}>{line}</p>;
                                                }

                                                if (line.type === "email") {
                                                    return (
                                                        <p key={i}>
                                                            <a href={`mailto:${line.value}`}>
                                                                <FiMail size={14} /> {line.value}
                                                            </a>
                                                        </p>
                                                    );
                                                }

                                                if (line.type === "phone") {
                                                    return (
                                                        <p key={i}>
                                                            <a href={`tel:${line.value}`}>
                                                                <FiPhone size={14} /> {line.value}
                                                            </a>
                                                        </p>
                                                    );
                                                }

                                                return null;
                                            })}
                                        </div>

                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </section>
            </div>
        </motion.div>
    );
};

export default Contact;
